import { DatePipe } from '@angular/common';
import { Component } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { Router } from '@angular/router';
import { MessagesService } from '../core/services/messages/messages.service';
import { RequestServiceService } from '../core/services/request-service/request-service.service';

@Component({
  selector: 'app-update-booking-status',
  templateUrl: './update-booking-status.component.html',
  styleUrls: ['./update-booking-status.component.scss']
})
export class UpdateBookingStatusComponent {
  // bookingForm: FormGroup;
  statusForm!: FormGroup;
  statusFlag: any
  bookingList: any[] = [];
  currentPage: number = 1;
  pageSize: number = 10;
  totalItems: number = 0;
  pages: number[] = [];
  fromDate: any;
  canceledList: any;
  //fromDate: Date | null = null;

  constructor(
    private fb: FormBuilder,
    private requestApiService: RequestServiceService,
    public router: Router,
    public messageservices: MessagesService, private datePipe: DatePipe
  ) {
    this.statusForm = this.fb.group({
      reserve_id: [''],
      status: [''],
      booking_cancel_type: [''],
      booking_cancel_reason: ['']
    });
  }
  applyFromDateFilter() {
    if (this.fromDate) {
      // Convert fromDate to a timestamp or format it as needed
      const fromDateTimestamp = this.datePipe.transform(this.fromDate, 'yyyy-MM-dd');
      // Update the fromDate variable
      this.fromDate = fromDateTimestamp;
      this.getBookingList(`page=${this.currentPage}&page_size=${this.pageSize}&is_paginated=true&from_date=${this.fromDate}&res_uid=bdbb63fa-6de0-11ee-85aa-0a95191eeb1e`);
    }
  }
  ngOnInit() {
    this.getBookingList(`page=${this.currentPage}&page_size=${this.pageSize}&is_paginated=true&res_uid=bdbb63fa-6de0-11ee-85aa-0a95191eeb1e`);
    this.getCancelledList()
  }

  getBookingList(url: string) {
    this.requestApiService.getBookingList(url).then(apiResponseData => {
      if (apiResponseData.success) {
        this.bookingList = apiResponseData.data.rows;
        this.totalItems = apiResponseData.data.count;
        this.calculatePageNumbers();
      }
    });
  }
  submitForm() {

  }

  // onSubmit() {
  //   // Uncomment and replace with your service call
  //   this.requestApiService.addResturantInfo(this.restaurantForm.value).then(response => {
  
  //     if (response.success) {
 
  //       // Handle successful login
  //       this.incorrect = false;
  //       this.message = response.msg;
       
  //       this.router.navigate([`/add-restaurant-slot/${response.data.res_uid}`]);
  //         this.messageservices.showNotification(response.msg,'success','success');
  //         localStorage.setItem("res_uid",response.data.res_uid);
  //     } else {
  //       this.incorrect = true;
  //       this.message = response.msg;
  //       this.messageservices.showNotification(response.msg,'error','error');

  //       // Handle login error
  //     }
  //   });
  // }
  getCancelledList() {
    this.requestApiService.cancelledBookingList().then(apiResponseData => {
      if (apiResponseData.success) {
        this.canceledList = apiResponseData.data.reasons;
      }
    });
  }

  calculatePageNumbers() {
    this.pages = [];
    const totalPages = Math.ceil(this.totalItems / this.pageSize);
    for (let i = 1; i <= totalPages; i++) {
      this.pages.push(i);
    }
  }
  performAction(action: string, reviewId: string) {
    const confirmation = confirm(`Are you sure you want to ${action} this review?`);
    if (confirmation) {
      this.requestApiService.performReviewAction({ "approved": action == 'approve' ? '1' : '0', 'review_id': reviewId }).then(response => {
        if (response.success) {
          this.messageservices.showNotification(response.msg, 'success', 'success');
          this.getBookingList(`page=${this.currentPage}&page_size=${this.pageSize}&is_paginated=true`);
        }
      });
    }
  }

  changeStatus() {

    if(this.statusForm.value.booking_cancel_type=='others'){
      this.statusFlag='1'
    }
  }
  changePage(page: number) {
    this.currentPage = page;
    const url = `page=${page}&page_size=${this.pageSize}&is_paginated=true`;
    this.getBookingList(url);
  }
}
